module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABH0lEQVRoQ+2VIXLCUBRF3zNgAUFFwwpYReobiSw7aDFlEShgCci6ZgFkFawgrcGAbGs+QxUg/gBnCJOZG3/ff/ecn8St5o/XfH9TgXsblAEZgAR0hSBAHJcBjBAOkAEIEMdlACOEA2QAAsRxGcAI4QAZgABxPGrgYxUazfX3xC287E8K5ovf7uN40Pe/2MlV5qIFPoty6uZvh8u62ew5TUaxAlXmogXy4mtjZq2TZbdZmrRjBarMXVEgbLK017m8wG1y8QLLcmbur0fLhjDPnnpH1+q0TF5h7syX2Ib/S4aw+HlI3s9/iW+f038Af8jhABmAAHFcBjBCOEAGIEAclwGMEA6QAQgQx2UAI4QDZAACxHEZwAjhABmAAHG89gZ2ziaHMWEnupgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/index-e_icon_A08.png
// module id = uuwL
// module chunks = 1